<template>
  <div style="text-align: left">
    <el-form ref="form" :model="form" label-width="80px">
      <el-form-item>
        <el-row>
          <el-col :span="1">区域</el-col>
          <el-col :span="6">
            <el-select v-model="form.province" placeholder="请选择" @change="provinceChanged">
              <el-option
                v-for="item in provinces"
                :key="item"
                :label="nameMappings[item]"
                :value="item">
              </el-option>
            </el-select>
          </el-col>
          <el-col :span="6">
            <el-select v-model="form.city" placeholder="请选择" @change="cityChanged">
              <el-option
                v-for="item in cities"
                :key="item"
                :label="nameMappings[item]"
                :value="item">
              </el-option>
            </el-select>
          </el-col>
          <el-col :span="6">
            <el-select v-model="form.district" placeholder="请选择">
              <el-option
                v-for="item in districts"
                :key="item"
                :label="nameMappings[item]"
                :value="item">
              </el-option>
            </el-select>
          </el-col>
        </el-row>
      </el-form-item>
      <el-form-item>
        <el-row>
          <el-col :span="1">类型</el-col>
          <el-col :span="5">
            <el-select v-model="form.type" placeholder="请选择" @change="cityChanged">
              <el-option
                v-for="item in types_for_checklist"
                :key="item"
                :label="item.name"
                :value="item.type">
              </el-option>
            </el-select>
          </el-col>
          <el-col :span="1">状态</el-col>
          <el-col :span="6">
            <el-select v-model="form.status" placeholder="请选择" @change="cityChanged">
              <el-option
                v-for="item in statuses"
                :key="item"
                :label="item.name"
                :value="item.status">
              </el-option>
            </el-select>
          </el-col>

          <el-col :span="3">
            <el-checkbox v-model="form.oilRequest">补货申请</el-checkbox>
          </el-col>
        </el-row>
      </el-form-item>
      <el-form-item>
        <el-row>
          <el-col :span="1">名称</el-col>
          <el-col :span="4">
            <el-input v-model="form.name" placeholder="请输入代理商名称">
            </el-input>
          </el-col>
          <el-col :span="1" :offset="1">电话</el-col>
          <el-col :span="5">
            <el-input v-model="form.mobile" placeholder="请输入代理商联系电话">
            </el-input>
          </el-col>
          <el-col :offset="10" :span="2">
            <el-button type="primary" @click="onQuery"><i class="el-icon-search"></i> 查询</el-button>
          </el-col>
        </el-row>
      </el-form-item>
    </el-form>

    <el-table
      :data="providerList"
      border
      style="width: 100%">
      <el-table-column
        fixed
        label="编号"
        width="150">
        <template slot-scope="scope">
          <router-link :to="{path: '/provider/details', query: {id: scope.row.id}}">{{scope.row.id}}</router-link>
        </template>
      </el-table-column>
      <el-table-column
        prop="name"
        label="名称"
        width="120">
      </el-table-column>
      <el-table-column
        prop="types"
        label="类型"
        width="120">
        <template slot-scope="scope">
          {{ types[scope.row.types - 1].name }}
        </template>
      </el-table-column>
      <el-table-column
        prop="mobile"
        label="电话"
        width="200">
      </el-table-column>
      <el-table-column
        prop="province"
        label="省份"
        width="120">
      </el-table-column>
      <el-table-column
        prop="city"
        label="市区"
        width="180">
      </el-table-column>
      <el-table-column
        prop="district"
        label="地区"
        width="120">
      </el-table-column>
      <el-table-column
        sortable
        prop="balance"
        label="余额"
        width="120">
        <template slot-scope="scope">
          {{ scope.row.balance / 100 }} 元
        </template>
      </el-table-column>
      <el-table-column
        label="注册时间"
        width="200">
        <template slot-scope="scope">
          {{ scope.row.et.substring(0, 10) }}
        </template>
      </el-table-column>
      <el-table-column
        prop="status"
        label="状态"
        width="120">
        <template slot-scope="scope">
          <el-tag size="small" :type="scope.row.status == 1 ? 'info' : (scope.row.status == 2 ? 'danger' : 'success') ">
            {{ scope.row.status == 1 ? '待审核' : (scope.row.status == 2 ? '被拒绝' : '已通过') }}
          </el-tag>
        </template>
      </el-table-column>
    </el-table>

    <el-pagination
      class="pagination"
      v-if="totalElements > 0"
      background
      layout="prev, pager, next"
      @current-change="handlePageChange"
      :current-page.sync="form.page"
      :page-size="form.pageSize"
      :total="totalElements">
    </el-pagination>
  </div>

</template>

<script>
import * as api from "@/js/api.js";

export default {
  name: "UserList",
  data() {
    return {
      types_for_checklist: [
        {type: 1, name: '省代'},
        {type: 2, name: '城市合伙人'},
        {type: 3, name: '汽车修理厂'},
        {type: 6, name: '市代'},
        {type: 5, name: '检测站'}
      ],
      types: [
        {type: 1, name: '省代'},
        {type: 2, name: '城市合伙人'},
        {type: 3, name: '汽车修理厂'},
        {type: 4, name: '备用'},
        {type: 5, name: '检测站'},
        {type: 6, name: '市代'},
      ],
      statuses: [
        {status: 0, name: '已下线'},
        {status: 1, name: '待审核'},
        {status: 2, name: '被拒绝'},
        {status: 10, name: '审核通过'}
      ],
      form: {
        oilRequest: false,
        name: '',
        mobile: '',
        province: '',
        city: '',
        district: '',
        type: '',
        since: null,
        status: '',
        page: 1,
        pageSize: 50
      },
      providerList: [],
      nameMappings: {},
      regionInfo: {},
      provinces: [],
      cities: [],
      districts: [],
      totalElements: 0,
    }
  },
  methods: {
    handlePageChange() {
      this.onQuery()
    },
    onQuery() {
      const query = this.form
      api.providerQuery(query).then(res => {
        let result = res.data
        if (result.error) {
          this.$message.error('请求区域信息出错');
        } else {
          this.providerList = result.data.content
          this.totalElements = result.data.totalElements
        }
      })
    },
    provinceChanged() {
      this.cities = this.regionInfo.provinceCityMapping[this.form.province]
      this.form.district = ''
      this.form.city = ''
      this.districts = []
    },
    cityChanged() {
      this.districts = this.regionInfo.cityDistrictMapping[this.form.city]
      this.form.district = ''
    }
  },

  mounted() {
    let that = this
    if (this.$store.state.RegionInfo) {
      this.regionInfo = this.$store.state.RegionInfo
      this.provinces = this.regionInfo.provinces
      this.nameMappings = this.regionInfo.codeNameMappings
    } else {
      api.getRegions({}).then(res => {
        let result = res.data
        if (result.error) {
          this.$message.error('请求区域信息出错');
        } else {

          this.regionInfo = result.data
          this.provinces = result.data.provinces
          this.nameMappings = result.data.codeNameMappings

          that.$store.commit('update', ['RegionInfo', this.regionInfo])
        }
      })
    }
    this.onQuery()
  },
}
</script>

<style scoped>
.pagination {
  margin-top: 15px;
}
</style>



// WEBPACK FOOTER //
// src/pages/providers/ProviderList.vue